var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("td", { staticClass: "py-4 pr-4" }, [
    _c(
      "div",
      { staticClass: "flex flex-wrap" },
      [
        _vm._l(_vm.items.slice(0, this.limit), function (item, i) {
          return _c(
            "span",
            {
              key: i,
              staticClass:
                "bg-primary-500 border border-primary-500 rounded-full text-white py-1 px-3 text-xs mx-0.5 mb-1 whitespace-no-wrap",
            },
            [_vm._v(_vm._s(item))]
          )
        }),
        _vm.items.length > this.limit
          ? _c(
              "span",
              {
                staticClass:
                  "border border-primary-500 hover:bg-gray-200 hover:border-transparent transition duration-300 rounded-full text-gray-600 py-1 px-3 text-xs mx-0.5 mb-1 cursor-pointer",
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.expand.apply(null, arguments)
                  },
                },
              },
              [_vm._v(_vm._s(_vm.items.length - 3) + " more")]
            )
          : _vm._e(),
        _vm.items.length === this.limit && _vm.items.length > 3
          ? _c(
              "span",
              {
                staticClass:
                  "flex items-center justify-center transition duration-100 bg-gray-200 rounded-full w-7 h-7 text-gray-600 text-xs mx-0.5 mb-1 cursor-pointer hover:bg-red-400 hover:text-white",
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.collapse.apply(null, arguments)
                  },
                },
              },
              [
                _c(
                  "svg",
                  {
                    staticClass: "w-3 h-3",
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      fill: "none",
                      viewBox: "0 0 24 24",
                      stroke: "currentColor",
                    },
                  },
                  [
                    _c("path", {
                      attrs: {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M6 18L18 6M6 6l12 12",
                      },
                    }),
                  ]
                ),
              ]
            )
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }